
import { BuilderElementControls } from "@/types/elements";
import Vue from "vue";
import { Component, Inject, Prop } from "vue-property-decorator";
import ControlSectionOrControl from "./ControlSectionOrControl.vue";
import draggable from "vuedraggable";
import { Control } from "@/types/controls";
import { ElementStudioContext } from "@/components/ElementStudio/ElementStudioTabsAndPanels.vue";
import { uiStore } from "@/store/store-accessor";

@Component({
  components: {
    ControlSectionOrControl,
    draggable
  }
})
export default class ElementStudioControls extends Vue {
  @Prop()
  value!: BuilderElementControls;

  @Prop()
  section!: "design" | "content";

  @Inject("context") readonly context!: ElementStudioContext;

  get sectionName() {
    return `${this.section}Sections`;
  }

  handleDrag(newControls: Control[]) {
    this.context.replaceControls(this.sectionName, newControls);
  }

  get canPaste() {
    return (
      uiStore.clipboard.elementStudio &&
      uiStore.clipboard.elementStudio.copiedControl
    );
  }

  handlePaste() {
    if (!uiStore.clipboard.elementStudio) return;

    const controlToPaste = uiStore.clipboard.elementStudio.copiedControl;

    if (!controlToPaste) return;

    this.context.pasteControl(this.sectionName, controlToPaste);
  }

  addSection() {
    this.context.addControl(this.sectionName, "section");
  }

  addPreset() {
    this.context.addPreset(this.sectionName);
  }
}
